<app-vvr-icon [dark]="true" [full]="true" [overlay]="true" [shadow]="false"></app-vvr-icon>
<div class="login-background">
    <div class="login-block">
        <div id="errorMessage">
            @if (validToken() == ValidationState.Validating) {
                De wachtwoordvalidatie token wordt gevalideerd.
            } @else if (validToken() == ValidationState.Invalid) {
                <p>Deze link is niet meer geldig.</p>
                <a class="textlink next" routerLink="/request-restore-password">Vraag hier een nieuwe link aan</a>
            } @else if (message) {
                {{message}}
            }
        </div>

        @if (validToken() == ValidationState.Valid) {
            <div>
                <form [formGroup]="form">
                    <div class="title">
                        <h1 class="h4 condensed">Nieuw wachtwoord</h1>
                    </div>
                    <mat-form-field appearance="fill" id="password">
                        <mat-label>Wachtwoord</mat-label>
                        <input
                            autocomplete="new-password"
                            formControlName="password"
                            matInput
                            name="password"
                            placeholder="Je nieuwe wachtwoord"
                            type="password">
                        @if (password.errors && password.errors.minlength) {
                            <mat-error>
                                Je wachtwoord is te kort
                            </mat-error>
                        } @else if (password.errors && password.errors.pattern && !password.errors.minlength) {
                            <mat-error>
                                Je wachtwoord is niet sterk genoeg
                            </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field appearance="fill" id="passwordconf">
                        <mat-label>Wachtwoord (herhaling)</mat-label>
                        <input
                            autocomplete="new-password"
                            formControlName="passwordconf"
                            matInput
                            name="passwordconf"
                            placeholder="Je wachtwoord ter bevestiging"
                            type="password">
                        <mat-error>De wachtwoorden moeten overeenkomen</mat-error>
                    </mat-form-field>
                    <div class="login-buttons">
                        <button
                            (click)="setNewPassword()"
                            [disabled]="form.invalid"
                            color="primary"
                            id="btn-setpassword"
                            mat-raised-button>
                            {{loading() ? 'We stellen je nieuwe wachtwoord in...' : 'Wachtwoord instellen'}}
                        </button>
                    </div>
                </form>
            </div>
        }
    </div>
</div>
